import React from 'react';
import { Navigate, NavLink, useParams } from 'react-router-dom';
import IncomeExpenses from './IncomeExpenses';
import ReferralBusiness from './ReferralBusiness/ReferralBusiness';
import { useAllowedSections } from '../customHooks';

const TABS = [
  { tab: '', to: '/income_expenses', label: 'Income & Expenses', section: 'income_expenses', element: <IncomeExpenses /> },
  { tab: 'referral-business', to: '/income_expenses/referral-business', label: 'Referral Business', section: 'referral-business', element: <ReferralBusiness /> },
];

export const INCOME_EXPENSES_SECTIONS = TABS.map((t) => t.section);

const IncomeExpensesPanel = () => {
  const { tab = '' } = useParams();
  const allowedSections = useAllowedSections();
  const visibleTabs = TABS.filter((t) => allowedSections.includes(t.section));
  const active = visibleTabs.find((t) => t.tab === tab);

  if (!active) {
    const fallback = visibleTabs[0];
    return fallback ? <Navigate to={fallback.to} replace /> : null;
  }

  return (
    <div className="w-full">
      {visibleTabs.length > 1 && (
        <div className="px-4 pt-4 md:px-6">
          <div className="inline-flex w-fit max-w-full flex-wrap gap-1 rounded-xl border border-slate-200 bg-slate-100 p-1">
            {visibleTabs.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                end
                className={({ isActive }) =>
                  `rounded-lg px-4 py-1.5 text-sm font-medium transition focus:outline-none focus-visible:ring-2 focus-visible:ring-sky-500 ${
                    isActive ? 'bg-white text-sky-700 shadow-sm' : 'text-slate-600 hover:bg-white/60 hover:text-slate-900'
                  }`
                }
              >
                {item.label}
              </NavLink>
            ))}
          </div>
        </div>
      )}
      {active.element}
    </div>
  );
};

export default IncomeExpensesPanel;
